// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oKu4","toggle":"styles_toggle__21b3o","preview":"styles_preview__17uHD"};